import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';

const ErrorModal = ({ errorBBModal, occurences, currentOccurence, ctaMethod, IBAN }) => {
  const handleOk = () => {
    ctaMethod();
    errorBBModal.disable();
  };
  const { publicRuntimeConfig } = getConfig();

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: IBAN ? 'Check_invalid_iban' : 'Error_1_try_again',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);
  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={currentOccurence !== 0 && currentOccurence <= occurences && errorBBModal.value}
      handleClose={() => {
        errorBBModal.disable();
      }}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      iconAlt={cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.alternativeText}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
        ${
          cmsCollectionData?.attributes?.secondHalfDescription
            ? cmsCollectionData?.attributes?.secondHalfDescription
            : ''
        }
        `}
      cta={
        IBAN
          ? [
              {
                // text: 'Try again',
                text: cmsCollectionData?.attributes?.cta[0]?.name
                  ? cmsCollectionData?.attributes?.cta[0]?.name
                  : 'Try again',
                ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                  ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                  : '',
                type: 'solid',
                action: () => handleOk(errorBBModal),
              },
            ]
          : [
              {
                // text: 'Try again',
                text: cmsCollectionData?.attributes?.cta[0]?.name
                  ? cmsCollectionData?.attributes?.cta[0]?.name
                  : 'Try again',
                ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                  ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
                  : '',
                type: 'solid',
                action: () => handleOk(errorBBModal),
              },
              // {
              //   text: 'Call 1800 303 641',
              //   type: 'contained',
              //   action: () => {
              //     window.location.href = publicRuntimeConfig.NEXT_PUBLIC_PATH;
              //   },
              // },
            ]
      }
      disableCloseOnBackdropClick={false}
      disableCloseOnEscapeKeyDown={false}
      disablecta={false}
      load={load}
    />
  );
};
export default ErrorModal;
